(function($) {



    function ShowMenuItem(elements){
        $($(elements).get().reverse()).each(function(i){
            var item = $(this);
    
            setTimeout(function(){
                item.addClass('show-menu-item');
            },i*50);
    
        });
    }
    

    function HideMenuItem(elements){
        $($(elements).get().reverse()).each(function(i){
            var item = $(this);
    
            setTimeout(function(){
                item.removeClass('show-menu-item');
                //item.addClass('hide-menu-item');
            },i*50);
    
        });
    }


    


    jQuery('.smx-navbar-toggler').on('click', function () {

        //alert('prova');
        var open = this.getAttribute("aria-expanded");
        
    
        if( open == 'false' ){
            jQuery('#menu-overlay').addClass('menu-show');

            setTimeout(function(){
                ShowMenuItem('.navbar-nav > .menu-item');
            },800);

            
        }else{
            jQuery('#menu-overlay').removeClass('menu-show');
            HideMenuItem('.navbar-nav > .menu-item');
        }
      })
    
    
    jQuery('#menu-overlay').on('click', function() {
        var toggler = jQuery('.smx-navbar-toggler');
        var navbar = jQuery('#navbarNavDropdown');
        
    
        if(navbar.hasClass('show')){
            navbar.removeClass('show');
            toggler.attr("aria-expanded","false");
            jQuery('#menu-overlay').removeClass('menu-show');
            jQuery('html').removeClass('overflow-hidden');
            HideMenuItem('.navbar-nav > .menu-item');
        }
    
    });

    


})
(jQuery); 